<script>
  import { onMount } from "svelte";
  import Split from "split.js";
  import Header from "./Header.svelte";
  import SidebarLeft from "./SidebarLeft.svelte";
  import Maplibre from "./Maplibre.svelte";
  import { hooksStore } from "../../stores/hooks.store";
  import Datagrid from "./datagrid/Datagrid.svelte";
  import Confirm from "../../components/Confirm/Confirm.svelte";
  import { tempStore } from "../../stores/temp.store";
  import { get as get_store } from "svelte/store";
  import get from "get-value";
  import set from "set-value";

  let split;
  /**
   * loaded - najprv sa musi nacitat dashboard, az potom datagrid
   * nakolko datagrid upravuje velkost splitu
   */
  let loaded = false;
  $: dialogCallback = null;
  $: showDialog = false;
  $: dialogTexts = {
    title: "Všetky aktívne kreslenia sa zmažú.",
    text: "Chcete pokračovať?",
    confirm: "Áno",
    cancel: "Zrušiť",
  };

  hooksStore.addAction("setSplitSize", "Dashboard.svelte", setSplitSize);
  hooksStore.addAction("collapseSplit", "Dashboard.svelte", collapseSplit);
  hooksStore.addAction("unhideSplit", "Dashboard.svelte", unhideSplit);
  hooksStore.addAction("confirmDialog", "Dashboard.svelte", confirmDialog);
  onMount(() => {
    // treba nastavit spliter, ktory rozdeluje obrazokvku na mapu a tabulku udajov
    split = Split([".panel1", ".panel2"], {
      sizes: [100, 0],
      minSize: [300, 0],
      direction: "vertical",
      cursor: "row-resize",
      expandToMin: true,
      onDrag: (sizes) => {
        // pri upravovani velkosti treba menit aj velkost canvasu kde je mapa
        hooksStore.doAction("resizeMaplibre");
      },
      onDragEnd: (sizes) => {
        let store = get_store(tempStore);

        if (sizes[1] < 1) {
          hooksStore.doAction("skryDatagrid");
        } else {
          // ak som menil velkost datagridu, tak si to ulozim do temp
          set(store, "spliteResized", true);
          tempStore.set(store);
        }

        hooksStore.doAction("resizeMaplibre");
      },
    });
    collapseSplit();
    loaded = true;
  });

  function unhideSplit() {
    if (document.querySelector(".splitter .gutter").style.display === "none") {
      document.querySelector(".splitter .gutter").style.display = "block";
      document.querySelector(".splitter .panel1").style.height = "";
      document.querySelector(".splitter .panel2").style.display = "block";
    }
  }

  function setSplitSize(sizes) {
    split.setSizes(sizes);
    hooksStore.doAction("resizeMaplibre");
  }

  function collapseSplit() {
    split.collapse(1);
    document.querySelector(".splitter .gutter").style.display = "none";
    document.querySelector(".splitter .panel1").style.height = "100%";
    document.querySelector(".splitter .panel2").style.display = "none";
    hooksStore.doAction("resizeMaplibre");
  }

  function confirmDialog(props) {
    dialogTexts = props.texts;
    dialogCallback = props.callback;
    showDialog = true;
  }
</script>

<Header />
<SidebarLeft />
<!-- Content start -->
<div class="content--layout">
  <div class="splitter split">
    <div class="panel1">
      <!-- Map start  -->

      <Maplibre />
    </div>
    <div class="panel2">
      {#if loaded}
        <Datagrid />
      {/if}
    </div>
  </div>
  <Confirm
    confirmTitle={dialogTexts.confirm}
    cancelTitle={dialogTexts.cancel}
    {showDialog}
    callback={dialogCallback}
    on:closeDialog={() => (showDialog = false)}
  >
    <span slot="title">
      {dialogTexts.title}
    </span>
    <span slot="description">
      {dialogTexts.text}
    </span>
  </Confirm>
</div>

<style lang="scss">
  .splitter {
    height: 100%;
    .panel1 {
      height: 100%;
    }
  }
</style>
